<template>
  <!-- RFM自定义分析 -->
  <div class="member-level" style="margin: 10px 20px">
    <div class="section-right-content-box">
      <div class="rfmTitle">RFM 自定义分析</div>

      <div class="" style="border-top: 1px solid #f0f0f0; margin: 16px -20px 30px -28px"></div>
      <div class="rfmTitle">
        <div>
          <el-radio-group v-model="radio" @change="changeRadio">
            <el-radio :label="1">R值分析</el-radio>
            <el-radio :label="2">F值分析</el-radio>
            <el-radio :label="3">M值分析</el-radio>
          </el-radio-group>
        </div>
        <div style="text-align: right;">
          <span class="top_des_text">
            <img
              src="@/assets/images/new_icon_waring_yellow.png"
              style="
              display: inline-block;
              float: left;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin-right: 5px;
            "
            />
            注意：由于数据量大，最新修改的数据<span style="color:red">5</span>分钟后生效，请稍后再查看哦~
          </span>
          <span class="create_btn3" @click="customBtn()">
            自定义参数
          </span>
          <span class="create_btn3 export_btn" @click="exportFn">
            导出数据
          </span>
        </div>
      </div>
      <!-- RFM自定义分析表格 -->
      <div class="table-box" v-loading="loading">
        <div class="table-panel">
          <div class="left">
            <el-row class="header-row">
              <el-col :span="11">
                <div class="header-top"></div>
                <div class="header-cell">会员类型</div>
              </el-col>
              <el-col :span="13">
                <div class="header-top"></div>
                <div class="header-cell">条件设置</div>
              </el-col>
            </el-row>
            <el-row class="table-row" v-for="(item, index) in curTableData" :key="index">
              <!-- 会员类型 -->
              <el-col :span="11" class="table-col">
                <div class="col-cell">{{ item.name }}</div>
              </el-col>
              <!-- 条件设置 -->
              <el-col :span="13" class="table-col">
                <div class="col-cell">
                  {{ item.condition }}
                  <!-- <span v-if="index === 9">
                    <el-select style="width: 85px" v-model="value2" placeholder="请选择" @change="change">
                      <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </span> -->
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="right">
            <el-row class="header-row">
              <!-- 会员数 -->
              <el-col :span="5">
                <div class="header-top"></div>
                <div class="header-cell">会员数(人)</div>
              </el-col>
              <!-- 消费金额 -->
              <el-col :span="5">
                <div class="header-top"></div>
                <div class="header-cell">消费金额(元)</div>
              </el-col>
              <!-- 客单价 -->
              <el-col :span="4">
                <div class="header-top"></div>
                <div class="header-cell">客单价(元)</div>
              </el-col>
              <!-- 占比分析 -->
              <el-col :span="6">
                <div class="header-top">占比分析</div>
                <div class="header-cell">
                  <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                      <span class="circle member-count-circle"></span>
                      <span class="price-label">会员数</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="circle"></span>
                      <span class="price-label">成交金额</span>
                    </el-col>
                  </el-row>
                  <div></div>
                </div>
              </el-col>
              <!-- 相关操作 -->
              <el-col :span="4" style="text-align: center">
                <div class="header-top"></div>
                <div class="header-cell">相关操作</div>
              </el-col>
            </el-row>

            <el-row class="table-row" v-for="(item, index) in curConsumerCustomers" :key="index">
              <el-col :span="5" class="table-col">
                <div class="col-cell member-count-cell">
                  {{ item.buyerNum }}
                </div>
              </el-col>
              <el-col :span="5" class="table-col">
                <div class="col-cell col-cell-price">{{ item.amount }}</div>
              </el-col>
              <el-col :span="4" class="table-col">
                <div class="col-cell col-cell-price">
                  {{ item.customerPrice }}
                </div>
              </el-col>
              <el-col :span="6" class="table-col">
                <div class="price-cell">
                  <div class="price-item">
                    <span class="price-span">{{ item.memberPercent }}%</span>
                    <el-progress
                      :percentage="item.memberPercent"
                      :show-text="false"
                      style="
                        float: right;
                        width: 105px;
                        margin-top: 7px;
                        margin-right: 10px;
                      "
                    ></el-progress>
                  </div>
                  <div class="price-item">
                    <span class="price-span member-count">{{ item.buyerMoneyPercent }}%</span>
                    <el-progress
                      :percentage="item.buyerMoneyPercent"
                      color="rgba(255, 118, 0, 1)"
                      :show-text="false"
                      style="
                        float: right;
                        width: 105px;
                        margin-top: 7px;
                        margin-right: 10px;
                      "
                    ></el-progress>
                  </div>
                </div>
              </el-col>
              <el-col :span="4" class="table-col" style="text-align: center">
                <span
                  class="col-cell marketing-cell"
                  @click="Affiliate_marketing(item, index)"
                  v-zoom="{ from: '数据分析-RFM自定义分析', name: '会员营销' }"
                  v-if="item.buyerNum != 0"
                  >会员营销</span
                >
                <span class="col-cell marketing-cell marketing-cellDefulat" v-else>会员营销</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <el-dialog title="设置RFM参数" :visible.sync="RFMvisible" width="600px" @close="RFMvisible = false" class="addMemberDialog">
        <div class="RFMBox">
          <div>R：最近一次购买时间</div>
          <div class="RFMBox-top">
            <span style="color:#000">0</span>&nbsp; - &nbsp;
            <!-- <el-input style="width:70px" @input.native="checkputn($event)" @change="handleRFM()" v-model="Ritem.oneinfo"></el-input> -->
            <el-input style="width:70px" :value="Ritem.oneinfo" @input='e => Ritem.oneinfo = validSe (e)' @change="handleRFM()" ></el-input>&nbsp; -
            &nbsp;<el-input style="width:70px" :value="Ritem.twoinfo"  @input='e => Ritem.twoinfo = validSe (e)' @change="handleRFM()" ></el-input>&nbsp; -
            &nbsp;<el-input style="width:70px" :value="Ritem.threeinfo" @input='e => Ritem.threeinfo = validSe (e)'  @change="handleRFM()"></el-input>&nbsp; -
            &nbsp;<el-input style="width:70px" :value="Ritem.fourinfo" @input='e => Ritem.fourinfo = validSe (e)' @change="handleRFM()" ></el-input>
          </div>
          <div class="RFMBox-top">
            R≤{{ Ritem.oneinfo == "0" ? "" : Ritem.oneinfo }}，{{ Ritem.oneinfo == "0" ? "" : Ritem.oneinfo }}＜R≤{{ Ritem.twoinfo }}，{{
              Ritem.twoinfo
            }}＜R≤{{ Ritem.threeinfo }}，{{ Ritem.threeinfo }}＜R≤{{ Ritem.fourinfo }}，R＞{{ Ritem.fourinfo }}
          </div>
        </div>
        <div class="RFMBox">
          <div>F：购买次数</div>
          <div class="RFMBox-top">
            <el-input style="width:70px" :value="Fitem.oneinfo"   @input='e => Fitem.oneinfo = validSe (e)'  @change="handleRFM()"></el-input>&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Fitem.twoinfo"   @input='e => Fitem.twoinfo = validSe (e)'  @change="handleRFM()"></el-input>&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Fitem.threeinfo" @input='e => Fitem.threeinfo = validSe (e)'  @change="handleRFM()" ></el-input>&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Fitem.fourinfo"  @input='e => Fitem.fourinfo = validSe (e)' @change="handleRFM()" ></el-input>
          </div>
          <div class="RFMBox-top">F={{ Fitem.oneinfo }}，F={{ Fitem.twoinfo }}，F={{ Fitem.threeinfo }}，F≥{{ Fitem.fourinfo }}</div>
        </div>
        <div class="RFMBox">
          <div>M：购买金额</div>
          <div class="RFMBox-top">
            <span style="color:#000">0</span>&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Mitem.oneinfo"   @input='e => Mitem.oneinfo = validSe (e,1)' @change="handleRFM()" ></el-input>&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Mitem.twoinfo"   @input='e => Mitem.twoinfo = validSe (e)' @change="handleRFM()"></el-input>&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Mitem.threeinfo" @input='e => Mitem.threeinfo = validSe (e)' @change="handleRFM()" ></el-input>&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Mitem.fourinfo"  @input='e => Mitem.fourinfo = validSe (e)' @change="handleRFM()"></el-input>
          </div>
          <div class="RFMBox-top">
            M≤{{ Mitem.oneinfo == "0" ? "" : Mitem.oneinfo }}，{{ Mitem.oneinfo == "0" ? "" : Mitem.oneinfo }}＜M≤{{ Mitem.twoinfo }}，{{
              Mitem.twoinfo
            }}＜M≤{{ Mitem.threeinfo }}，{{ Mitem.threeinfo }}＜M≤{{ Mitem.fourinfo }}，M＞{{ Mitem.fourinfo }}
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="cancel_Btn" @click="RFMvisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave()" class="sure_Btn">确 定</el-button>
        </span>
      </el-dialog>
    </div>
     <!-- 生成报表 -->
     <generate :control = 'control' 
               v-if="control" 
               @transData="(val) => (control = val)"
               @transData1 = 'getphone1'
               ></generate>
  </div>
</template>

<script>
import { RFM_Customize_Analyse, queryByNumChange, getAnalyse, analyseconfig, exportData } from "@/api/analysis/rfmStandard";
import generate from '../../components/generate_report.vue'

// import { close } from 'fs';
export default {
  name: "RFM_custom_analysis",
  data() {
    return {
      control:false,
      radio: 1,
      loading: false,
      Ritem: {
        oneinfo: "7",
        twoinfo: "30",
        threeinfo: "90",
        fourinfo: "120",
      },
      Fitem: {
        oneinfo: "1",
        twoinfo: "2",
        threeinfo: "3",
        fourinfo: "4",
      },
      Mitem: {
        oneinfo: "20",
        twoinfo: "50",
        threeinfo: "100",
        fourinfo: "150",
      },
      RFMvisible: false,
      options2: [
        {
          value: "20",
          label: "20",
        },
        {
          value: "50",
          label: "50",
        },
        {
          value: "100",
          label: "100",
        },
        {
          value: "200",
          label: "200",
        },
      ],
      value2: "20",
      time: "",
      levelList: [
        {
          id: "cake-chart-0",
        },
        {
          id: "cake-chart-1",
        },
        {
          id: "cake-chart-2",
        },
        {
          id: "cake-chart-3",
        },
        {
          id: "cake-chart-4",
        },
      ],
      /*
       * 表格内容
       * */
      curTableData: [],
      curConsumerCustomers: [],
      tableData: [
        {
          m_bf: 10,
          momey: "10000.00",
          p_bf: 30,
          people: "10",
          price: "1000.00",
          name: "售后期客户",
          condition: "R ≤ 7 ",
          day: "7",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "0",
          p_bf: 0,
          people: "0",
          price: "0",
          name: "活跃期客户",
          condition: "7 < R ≤ 30",
          day: "730",
          RFMlist: [],
        },
        {
          m_bf: 10,
          momey: "100.00",
          p_bf: 10,
          people: "1",
          price: "100.00",
          name: "沉默期客户",
          condition: "30 < R ≤ 90",
          day: "3090",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "睡眠期客户",
          condition: "90 < R ≤ 120",
          day: "90120",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "流失期客户",
          condition: "R > 120",
          day: "120",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "兴趣客户",
          condition: " F = 0",
          number: "1",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "新客户",
          condition: "	F = 1",
          number: "2",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "回头客",
          condition: "	F = 2",
          number: "3",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "老客户",
          condition: "F ≥ 3",
          number: "4",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "低消费客户",
          condition: "0 < M ≤ 20",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "中低消费客户",
          condition: "	20 < M ≤ 50",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "中等消费客户",
          condition: "	50 < M ≤ 100",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "中高消费的客户",
          condition: "100 < M ≤ 150",
          RFMlist: [],
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "高消费客户",
          condition: "M > 150",
          RFMlist: [],
        },
      ],
      tableDataList: [],
      ConsumerCustomers: [],
    };
  },
  components: {
    generate
  },
  created () {
    // 埋点
    this.buriedPoint(1, 'RFM值分析(POP)', '数据分析', 'RFM分析')
  },
  mounted() {
    // this.info();
    this.getInfo();
    this.change();
    this.tablehandle("1");
    setTimeout(() => {
      this.changeRadio(1)
    },300)
  },
  methods: {
    changeRadio(val) {
      if (val === 1) {
        this.curTableData = this.tableData.slice(0,5)
      } else if(val === 2) {
        this.curTableData = this.tableData.slice(5,9)
      } else {
        this.curTableData = this.tableData.slice(9)
      }
      this.change()
    },

    // 导出数据
    async exportFn() {
      this.control = true
    },
    getphone1(val){
      let params = {
        exportRemark:val
      }
      exportData(params).then((res)=>{
        if(res.code==1){
          this.control = true
        }else{
          this.$message.error(res.message)
        }
      })
    },

    async handleSave() {
      // Fitem
      if (this.Fitem.threeinfo && this.Fitem.oneinfo && this.Fitem.twoinfo && this.Fitem.fourinfo) {
        const fnum = [this.Fitem.threeinfo, this.Fitem.oneinfo, this.Fitem.twoinfo, this.Fitem.fourinfo];
        const fnumlist = [...new Set(fnum)];
        if (fnumlist.length != 4) {
          return this.$message.warning("F：购买次数的值不能相等");
        }
      }
      if (!this.Ritem.oneinfo || !this.Ritem.twoinfo || !this.Ritem.threeinfo || !this.Ritem.fourinfo) {
        this.$message.warning("请将最近一次购买时间填写完整");
        return;
      }
      if (!this.Fitem.oneinfo || !this.Fitem.twoinfo || !this.Fitem.threeinfo || !this.Fitem.fourinfo) {
        this.$message.warning("请将购买次数填写完整");
        return;
      }
      if (!this.Mitem.oneinfo || !this.Mitem.twoinfo || !this.Mitem.threeinfo || !this.Mitem.fourinfo) {
        this.$message.warning("请将购买金额填写完整");
        return;
      }
      const params = {
        payDateCondition: `0,${this.Ritem.oneinfo},${this.Ritem.twoinfo},${this.Ritem.threeinfo},${this.Ritem.fourinfo}`,
        payTimeCondition: `${this.Fitem.oneinfo},${this.Fitem.twoinfo},${this.Fitem.threeinfo},${this.Fitem.fourinfo}`,
        payAmountCondition: `0,${this.Mitem.oneinfo},${this.Mitem.twoinfo},${this.Mitem.threeinfo},${this.Mitem.fourinfo}`,
      };
      this.RFMvisible = false;
      const res = await analyseconfig(params);
      if (res.code == 1) {
        this.$confirm("由于数据量大，最新修改的数据5分钟后生效请稍后再查看哦~", "提示", {
          confirmButtonText: "我已知晓",
          type: "warning",
          customClass: "custom_analysis_deletesss",
          appendtobody: false,
        }).then(() => {});
        this.change();
        this.tablehandle("1");
      } else {
        this.$message.warning(res.message);
      }
    },
    // 自定义参数
    customBtn() {
      this.RFMvisible = true;
      this.tablehandle("2");
    },
    async change() {
      const res = await queryByNumChange();
      this.ConsumerCustomers = this.tableDataList.concat(res.data);
      if(this.radio === 1) {
        this.curConsumerCustomers = this.ConsumerCustomers.slice(0,5)
      } else if(this.radio === 2) {
        this.curConsumerCustomers = this.ConsumerCustomers.slice(5,9)
      } else {
        this.curConsumerCustomers = this.ConsumerCustomers.slice(9)
      }
      // then((res) => {
      //   console.log(res, 99999);
      //   this.ConsumerCustomers = this.tableDataList.concat(res.data);
      // });
    },
    validSe(data,type = 0){
      console.log('1111111',data)
      let filtered = data.replace(/[^\d]/g, "");
      if(type = 0){
        if (Number(filtered) < 1) {
        filtered = "";
        }
      }
      return filtered
    },

    async tablehandle(type) {
      const { data: res } = await getAnalyse({ type: type });
      // console.log(res, 4555);
      if (type === "1") {
        this.tableData[0].condition = `R ≤ ${res.payDateCondition[1]}`;
        this.tableData[0].RFMlist = [res.payDateCondition[0], res.payDateCondition[1]];
        this.tableData[1].condition = `${res.payDateCondition[1]} < R ≤ ${res.payDateCondition[2]}`;
        this.tableData[1].RFMlist = [res.payDateCondition[1], res.payDateCondition[2]];
        this.tableData[2].condition = `${res.payDateCondition[2]} < R ≤ ${res.payDateCondition[3]}`;
        this.tableData[2].RFMlist = [res.payDateCondition[2], res.payDateCondition[3]];
        this.tableData[3].condition = `${res.payDateCondition[3]} < R ≤ ${res.payDateCondition[4]}`;
        this.tableData[3].RFMlist = [res.payDateCondition[3], res.payDateCondition[4]];
        this.tableData[4].condition = ` R > ${res.payDateCondition[4]}`;
        this.tableData[4].RFMlist = [res.payDateCondition[4], 0];

        this.tableData[5].condition = `F = ${res.payTimeCondition[0]}`;
        this.tableData[5].RFMlist = [res.payTimeCondition[0]];
        this.tableData[6].condition = `F = ${res.payTimeCondition[1]}`;
        this.tableData[6].RFMlist = [res.payTimeCondition[1]];
        this.tableData[7].condition = `F = ${res.payTimeCondition[2]}`;
        this.tableData[7].RFMlist = [res.payTimeCondition[2]];
        this.tableData[8].condition = `F ≥ ${res.payTimeCondition[3]}`;
        this.tableData[8].RFMlist = [res.payTimeCondition[3]];

        this.tableData[9].condition = `M ≤ ${res.payAmountCondition[1]}`;
        this.tableData[9].RFMlist = [res.payAmountCondition[0], res.payAmountCondition[1]];
        this.tableData[10].condition = `${res.payAmountCondition[1]} < M ≤ ${res.payAmountCondition[2]}`;
        this.tableData[10].RFMlist = [res.payAmountCondition[1], res.payAmountCondition[2]];
        this.tableData[11].condition = `${res.payAmountCondition[2]} < M ≤ ${res.payAmountCondition[3]}`;
        this.tableData[11].RFMlist = [res.payAmountCondition[2], res.payAmountCondition[3]];
        this.tableData[12].condition = `${res.payAmountCondition[3]} < M ≤ ${res.payAmountCondition[4]}`;
        this.tableData[12].RFMlist = [res.payAmountCondition[3], res.payAmountCondition[4]];
        this.tableData[13].condition = ` M > ${res.payAmountCondition[4]}`;
        this.tableData[13].RFMlist = [res.payAmountCondition[4], ""];
      } else {
        this.Ritem.oneinfo = res.payDateCondition[1];
        this.Ritem.twoinfo = res.payDateCondition[2];
        this.Ritem.threeinfo = res.payDateCondition[3];
        this.Ritem.fourinfo = res.payDateCondition[4];

        this.Fitem.oneinfo = res.payTimeCondition[0];
        this.Fitem.twoinfo = res.payTimeCondition[1];
        this.Fitem.threeinfo = res.payTimeCondition[2];
        this.Fitem.fourinfo = res.payTimeCondition[3];

        this.Mitem.oneinfo = res.payAmountCondition[1];
        this.Mitem.twoinfo = res.payAmountCondition[2];
        this.Mitem.threeinfo = res.payAmountCondition[3];
        this.Mitem.fourinfo = res.payAmountCondition[4];
      }
      this.loading = false;
    },
    Affiliate_marketing(obj, index) {
      console.log(obj, index);
      
      let self = this;
      let type = "";
      if (index >= 0 && index <= 4) {
        type = "0";
      } else if (index >= 5 && index <= 8) {
        type = "1";
      } else {
        type = "2";
      }

      let price = this.tableData[index].RFMlist;


      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/member_send",
        query: {
          tabIndex: 1,
          type: type,
          index,
          price: price,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    async getInfo() {
      this.loading = true;
      const res = await RFM_Customize_Analyse();
      // .then((res) => {
      //   console.log(res.data, 111);

      // });
      this.tableDataList = res.data;
    },
    //输入框限制负数
    checkputn(e, num = "-1") {
      console.log('')
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      if (num == "-1") {
        if (Number(e.target.value) < 1) {
          e.target.value = "";
        }
      }
      // if (num == "0") {
      //   if (e.target.value < 1) {
      //     e.target.value = "";
      //   }
      // }
    },


    handleRFM() {
      const num1 = Number(this.Ritem.oneinfo);
      const num2 = Number(this.Ritem.twoinfo);
      const num3 = Number(this.Ritem.threeinfo);
      const num4 = Number(this.Ritem.fourinfo);
      const fnum1 = Number(this.Fitem.oneinfo);
      const fnum2 = Number(this.Fitem.twoinfo);
      const fnum3 = Number(this.Fitem.threeinfo);
      const fnum4 = Number(this.Fitem.fourinfo);
      const mnum1 = Number(this.Mitem.oneinfo);
      const mnum2 = Number(this.Mitem.twoinfo);
      const mnum3 = Number(this.Mitem.threeinfo);
      const mnum4 = Number(this.Mitem.fourinfo);
      // Ritem
      if (num1 >= num2 && this.Ritem.oneinfo && this.Ritem.twoinfo) {
        this.Ritem.twoinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (num2 >= num3 && this.Ritem.twoinfo && this.Ritem.threeinfo) {
        this.Ritem.threeinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (num3 >= num4 && this.Ritem.threeinfo && this.Ritem.fourinfo) {
        this.Ritem.fourinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      // Fitem
      if (this.Fitem.threeinfo && this.Fitem.oneinfo && this.Fitem.twoinfo && this.Fitem.fourinfo) {
        const fnum = [fnum1, fnum2, fnum3, fnum4];
        const fnumlist = [...new Set(fnum)];
        if (fnumlist.length != 4) {
          this.Fitem.oneinfo = ""
          this.Fitem.twoinfo = ""
          this.Fitem.threeinfo = ""
          this.Fitem.fourinfo = ""
          this.$message.warning("值不能相等");

        }
      }
      // Mitem
      if (mnum1 >= mnum2 && this.Mitem.oneinfo && this.Mitem.twoinfo) {
        this.Mitem.twoinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (mnum2 >= mnum3 && this.Mitem.twoinfo && this.Mitem.threeinfo) {
        this.Mitem.threeinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (mnum3 >= mnum4 && this.Mitem.threeinfo && this.Mitem.fourinfo) {
        this.Mitem.fourinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
    },
  },
};
</script>

<style lang="scss">
.custom_analysis_deletesss {
  .el-message-box__content {
    padding: 20px 30px !important;
    text-align: left !important;
  }
  .el-message-box__container {
    > .el-message-box__status {
      top: 28% !important;
    }
  }
  .el-message-box__btns {
    padding: 5px 43px 20px 15px !important;
    text-align: right !important;
    > .el-button:nth-of-type(1) {
      display: none !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.top_des_text {
  height: 28px;
  background: #fffaee;
  opacity: 1;
  border-radius: 14px;
  // line-height: 34px;
  display: inline-block;
  // padding: 0 12px;
  vertical-align: top;
  font-size: 14px;
  padding: 6px 12px;
  margin-top: 4px;
  // font-family: PingFang SC;
  font-weight: 350;
  color: rgba(51, 51, 51, 1);
}
.RFMBox {
  padding: 10px 0px 25px 17px;
  color: #000;
  .RFMBox-top {
    color: #999;
    margin-left: 24px;
    margin-top: 15px;
  }
}

.export_btn {
  margin-left: 12px;
}

.create_btn3 {
  width: 98px;
  height: 32px;
  opacity: 1;
  border-radius: 3px;
  display: inline-block;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  color: #ffffff;
  background-color: #fe4d45;
  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }
}
* {
  font-family: "Microsoft YaHei";
}
@mixin translateX($number) {
  -webkit-transform: translateX($number);
  -moz-transform: translateX($number);
  -ms-transform: translateX($number);
  -o-transform: translateX($number);
  transform: translateX($number);
}
@mixin translateY($number) {
  -webkit-transform: translateY($number);
  -moz-transform: translateY($number);
  -ms-transform: translateY($number);
  -o-transform: translateY($number);
  transform: translateY($number);
}
@mixin translate($number, $number2) {
  -webkit-transform: translateX($number) translateY($number2);
  -moz-transform: translateX($number) translateY($number2);
  -ms-transform: translateX($number) translateY($number2);
  -o-transform: translateX($number) translateY($number2);
  transform: translateX($number) translateY($number2);
}
/deep/.el-progress-bar__inner {
  background-color: #7f85e9;
}
.section-right-content-box {
  min-width: 1046px;
  background-color: #fff;
  /*box-shadow: 0px 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  padding: 33px 20px 16px 28px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid rgba(230, 230, 230, 1);
  opacity: 1;
  margin-top: 10px;
  .top-panel_span {
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #333333;
    opacity: 1;
  }
}
.rfmTitle {
  align-items: center;
  font-size: 16px;
  // font-family: PingFang SC;
  font-weight: bold;
  color: #2e3458;
  // margin: -15px 0 10px 0;
  display: flex;
  justify-content: space-between;
}

.table-box {
  margin-top: 14px;
  .table-panel {
    display: flex;
    border: 1px solid #e1e1e6;
    .left {
      width: 30%;
    }
    .right {
      width: 70%;
    }
    .header-row {
      padding: 17px 0 14px 15px;
      border-bottom: 1px solid #f2f2f2;
      .header-top {
        height: 20px;
        color: #333333;
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        text-align: center;
      }
      .header-cell {
        overflow: hidden;
        margin-top: 8px;
        color: #333333;
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        // .price-label {
        //   // float: left;
        // }
        .member-count-label {
          padding-left: 16px;
        }
        .circle {
          display: inline-block;
          // float: left;
          width: 8px;
          height: 8px;
          margin-right: 4px;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
          background-color: #7f85e9;
          // margin-top: 4px;
          // margin-left: 2px;
        }
        .member-count-circle {
          background-color: #ff974a;
        }
      }
    }
    .table-row {
      padding-bottom: 10px;
      padding-left: 15px;
      border-bottom: 1px solid #f2f2f2;
      line-height: 52px;
      .table-col {
        display: inline;
        vertical-align: middle;
        min-height: 10px;
        .col-cell {
          font-size: 14px;
          color: #666666;
          border-radius: 3px;
        }
        .member-count-cell {
          color: #7f85e9;
          font-size: 16px;
        }
        .col-cell-price {
          color: #ff974a;
          font-size: 16px;
        }
        .marketing-cell {
          padding: 6px;
          color: #fe4d45;
          border-radius: 3px;
          cursor: pointer;
          background: #fff;
          border: 1px solid #fe4d45;
        }
        .marketing-cell:hover {
          background: #fe4d45;
          color: #fff;
        }
        .marketing-cellDefulat {
          color: #909399;
          background: #f4f4f5;
          border-color: #d3d4d6;
        }
        .marketing-cellDefulat:hover {
          background: #cccccc;
          color: #fff;
          cursor: not-allowed;
        }
      }
      .price-cell {
        margin-top: 6px;
        .price-item {
          overflow: hidden;
          line-height: 20px;
          .price-span {
            float: left;
            color: #7f85e9;
            font-size: 14px;
            font-weight: 500;
          }
          .member-count {
            color: #ff974a;
          }
        }
      }
    }
    .table-row:last-child {
      border-bottom: none;
    }
  }
}
</style>
